import React from "react";
import * as styles from "./banner.module.scss";
import bannerpic1 from "../../../images/banner-service/frame1.png";
import bannerpic2 from "../../../images/banner-service/frame2.png";

const Banner = ({ title }) => {
  return (
    <section className={styles.SectionBanner}>
      <div className={styles.imgContainer1}></div>
      <div className={styles.TextContainer}>
        <h2>{title}</h2>
      </div>
      <div className={styles.imgContainer2}></div>
    </section>
  );
};

export default Banner;
